import React from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import TopUrgencyBar from "@/components/TopUrgencyBar";
import Footer from "@/components/Footer";
import TicketsBlock from "@/components/TicketsBlock";
import { Lock, ArrowLeft, ArrowDown, Calendar, MapPin } from "lucide-react";

export default function EarlyAccess() {
  return (
    <div className="min-h-screen bg-[#FAFAF7] text-[#0A1128]">
      <Navbar />
      <TopUrgencyBar />

      {/* Hero with the screened-pool money shot */}
      <section className="relative pt-[136px] md:pt-[140px] pb-20 text-white overflow-hidden">
        <img
          src="/estate/indoor-pool.jpeg"
          alt="The SSU Workshops estate — West Palm Beach"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A1128]/85 via-[#0A1128]/75 to-[#0A1128]" />
        <div className="absolute inset-0 wave-bg opacity-30 pointer-events-none" />

        <div className="relative max-w-5xl mx-auto px-6 lg:px-12 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-[#FACC15] text-[#0A1128] rounded-full mb-6 text-[10px] font-black uppercase tracking-[0.25em]">
            <Lock size={11} /> Private Early Access · WhatsApp Community
          </div>
          <h1 className="font-display text-5xl md:text-7xl lg:text-[7rem] leading-[0.85] mb-6">
            Doors Open <span className="ssu-mark">Early.</span>
          </h1>
          <p className="text-lg md:text-xl text-white/85 max-w-2xl mx-auto mb-7 leading-relaxed">
            You&apos;re seeing this <span className="font-black text-[#FACC15]">2 hours before the public release</span> — that&apos;s the whole head start. First pick of beds, first pick of seats. When a tier sells out here, it&apos;s gone — the public release at noon inherits whatever&apos;s left.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-3 mb-8 text-sm">
            <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2">
              <Calendar size={14} className="text-[#FACC15]" />
              <span>Oct 1–4, 2026</span>
            </div>
            <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2">
              <MapPin size={14} className="text-[#FACC15]" />
              <span>West Palm Beach Estate</span>
            </div>
            <div className="inline-flex items-center gap-2 bg-[#FACC15] text-[#0A1128] rounded-full px-4 py-2 font-black">
              30 Seats Total
            </div>
          </div>

          <a
            href="#tickets"
            data-testid="early-jump-tickets"
            className="inline-flex items-center gap-2 px-6 py-3 bg-[#FACC15] hover:bg-[#FDE047] text-[#0A1128] font-black uppercase tracking-wider text-sm rounded-xl transition-colors"
          >
            See the Tickets <ArrowDown size={16} />
          </a>

          <div className="mt-6">
            <Link to="/" data-testid="early-back-home" className="text-xs text-white/55 hover:text-[#FACC15] transition-colors inline-flex items-center gap-1.5">
              <ArrowLeft size={12} /> Back to the main site
            </Link>
          </div>
        </div>
      </section>

      <TicketsBlock sectionId="tickets" showEarlyBadge={true} />

      {/* Closing urgency strip */}
      <section className="bg-[#FAFAF7] py-16">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <div className="font-display text-3xl md:text-4xl text-[#0A1128] mb-3 leading-tight">
            In 2 hours, this goes public.
          </div>
          <p className="text-[#4B5563] text-lg max-w-2xl mx-auto">
            At noon ET, the doors open to everyone. Anyone tries to grab the last women's bed, a women's bunk, or one of the weekend passes. Grab yours before they do.
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}
